// For Segment Page Call
export const PAGE_NAME = Object.freeze({
	ENTERPRISE_DOCUMENT_TYPE: 'Imaging Document Type',
	ENTERPRISE_DOCUMENT_REVISION: 'Imaging- File Upload',
	PAGINATION: 'Imaging Doc-Type Log',
	PM_HOME_PAGE: 'PM Project List',
	CREATE_RFI: 'Create New RFI',
	CREATE_ISSUE: 'Create New ISSUE',
	EXISTING_RFI: 'Add to Existing RFI- File Upload',
	EXISTING_ISSUE: 'Add to Existing Issue- File Upload',
	EXISTING_JOURNAL: 'Add to Existing Journal- File Upload',
	EXISTING_SUBMITTAL: 'Add to Existing Submittal- File Upload',
});

// For Segment Track Call
export const EVENT_NAME = Object.freeze({
	LOGIN: 'Login',
	ENTERPRISE_DOCUMENT_TYPE: 'Imaging Document Type',
	PAGINATION: 'Imaging Doc-Type Log',
	PM_SELECT_PROJECT: 'PM Project Selected',
	RFI_CREATED: 'New RFI Created',
	RFI_DRAFT: 'RFI Saved as Draft',
	ISSUE_CREATED: 'New Issue Created',
	ISSUE_DRAFT: 'Issue Saved as Draft',
	EXISTING_RFI_FILE_UPLOAD: 'Add to Existing RFI- File Upload',
	EXISTING_ISSUE_FILE_UPLOAD: 'Add to Existing Issue- File Upload',
	EXISTING_JOURNAL_FILE_UPLOAD: 'Add to Existing Journal- File Upload',
	EXISTING_SUBMITTAL_FILE_UPLOAD: 'Add to Existing Submittal- File Upload',
	CONSTRUCT_PM_REDIRECTION: 'Redirect to Construct PM',
	PM_DOCUMENT: 'Document Folder Clicked',
});
